module.exports = __webpack_public_path__ + "img/10.5a65ae7d.jpg";